import AccountPasswordRecover from './AccountPasswordRecover';

export default AccountPasswordRecover;
